interface RightLeafSVGProps {
  width?: number
  height?: number
  size?: number
  fill?: string
  color?: string
  className?: string
}

export default function RightLeafSVG({
  width = 19,
  height = 20,
  size,
  fill = '#992E00',
  color,
  className
}: RightLeafSVGProps) {
  const finalWidth = size ?? width
  const finalHeight = size ?? height
  const finalFill = color ?? fill

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={finalWidth}
      height={finalHeight}
      viewBox='0 0 19 20'
      fill='none'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.0808 1.85483C9.75122 1.32844 9.91048 0.634372 10.4365 0.304569C10.9625 -0.0252164 11.6561 0.134152 11.9857 0.660538L12.4665 1.4285C12.7961 1.95488 12.6368 2.64895 12.1108 2.97874C11.5847 3.30854 10.8911 3.14917 10.5616 2.62278L10.0808 1.85483ZM16.0679 3.18039C15.6172 2.74796 14.9055 2.75854 14.4782 3.20402L13.404 4.32388L11.598 3.82334C10.9977 3.65697 10.3819 4.007 10.2226 4.60515C10.0632 5.20328 10.4205 5.82305 11.0208 5.98942L13.472 6.66878C13.8697 6.77904 14.2934 6.66394 14.5766 6.36874L16.1102 4.77001C16.5375 4.32453 16.5186 3.61284 16.0679 3.18039ZM16.2333 7.01196C16.703 6.61143 17.4141 6.67046 17.8217 7.14379C18.2293 7.61711 18.1789 8.3255 17.7093 8.72603L15.5422 10.5741C15.2115 10.856 14.7445 10.9193 14.3448 10.7362L11.7252 9.53647C11.1575 9.27646 10.9029 8.60936 11.1566 8.04646C11.4104 7.48358 12.0763 7.23805 12.644 7.49807L14.6083 8.3977L16.2333 7.01196ZM11.7236 13.3896C11.1865 13.0762 11.0038 12.3876 11.3154 11.8516C11.6271 11.3155 12.3152 11.135 12.8523 11.4484L14.5975 12.4667L16.7561 11.595C17.3313 11.3628 17.9873 11.6413 18.2214 12.2172C18.4555 12.793 18.1791 13.4481 17.6039 13.6804L14.9343 14.7584C14.612 14.8886 14.2471 14.862 13.9461 14.6863L11.7236 13.3896Z'
        fill={finalFill}
      />
      <path
        d='M8.9142 14.504L9.6931 15.9958C8.88616 16.0601 6.78012 16.5409 4.81143 17.9493C4.3257 18.3358 4.24514 19.0434 4.63142 19.5297C5.01787 20.0157 5.72497 20.0963 6.21072 19.7098C6.53582 19.3574 7.77459 18.537 10.1289 18.0747C10.5175 18.0236 10.877 18.0611 11.2235 18.0747L11.3633 18.0611C11.3792 18.0623 11.3951 18.0632 11.4111 18.0638L15.1098 18.203C15.7364 18.2266 16.2759 17.7485 16.3146 17.135C16.3534 16.5214 15.8768 16.005 15.2501 15.9814L12.2025 15.8666L10.9443 13.4568C10.6615 12.9152 9.97784 12.7106 9.41726 12.9998C8.85667 13.289 8.63145 13.9625 8.9142 14.504Z'
        fill={finalFill}
      />
    </svg>
  )
}
